module.exports = __webpack_public_path__ + "static/media/billing-icon.83450102.svg";